import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  stepContainer: {
    flexDirection: 'row',
    marginBottom: Theme.px(26),
    minHeight: Theme.px(113),
    width: '100%',
  },
  stepContent: {
    paddingLeft: Theme.px(57),
  },
  stepIcon: {
    marginTop: Theme.px(16),
  },
});
